export default __webpack_public_path__ + "static/media/down_arrow_white.74957861.svg";